import { apiClient } from './client'

export type StatusData = {
  intelligence: number
  dexterity: number
  physical: number
  financial: number
  mental: number
  charm: number
  luck: number
  level: number
  /** 現在レベルの到達に必要な累計pt（進捗バーの下端） */
  current_level_points: number
  /** 次レベルの到達に必要な累計pt（進捗バーの上端） */
  next_level_points: number
  total_earned_points: number
}

export const getStatus = () =>
  apiClient.get<StatusData>('/status/').then((r) => r.data)
